import { ROUTES } from '#/config/routes';
import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';
import {
  formatDisplayAmount,
  formatDisplayQty,
} from '#/utils/formatNumber';

function displayDash(value) {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  return value;
}

function formatMtrNo(row) {
  return displayDash(row?.mtr?.mtrNo);
}

function formatMtrName(row) {
  return displayDash(row?.mtr?.name);
}

export function buildPurchaseOrderLineColumns() {
  return [
    {
      id: 'mtrNo',
      header: '料號',
      accessorFn: (row) => formatMtrNo(row),
      size: 160,
      minSize: 100,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => {
        const mtrId = row.original?.mtr?.id;
        return (
          <TruncatedTextWithTooltip
            text={formatMtrNo(row.original)}
            detailPath={mtrId ? ROUTES.mtrDetail(mtrId) : null}
          />
        );
      },
    },
    {
      id: 'mtrName',
      header: '料名',
      accessorFn: (row) => formatMtrName(row),
      size: 200,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => {
        const mtrId = row.original?.mtr?.id;
        return (
          <TruncatedTextWithTooltip
            text={formatMtrName(row.original)}
            detailPath={mtrId ? ROUTES.mtrDetail(mtrId) : null}
          />
        );
      },
    },
    {
      id: 'unitPrice',
      header: '單價',
      accessorFn: (row) => formatDisplayAmount(row.unitPrice),
      size: 100,
      enableSorting: false,
    },
    {
      id: 'orderQty',
      header: '訂購數量',
      accessorFn: (row) => formatDisplayQty(
        row?.qtySummary?.orderQty ?? row?.orderQty,
      ),
      size: 110,
      enableSorting: false,
    },
    {
      id: 'amount',
      header: '小計',
      accessorFn: (row) => (
        row?.amount == null || row.amount === ''
          ? '—'
          : formatDisplayAmount(row.amount)
      ),
      size: 110,
      enableSorting: false,
      meta: { cellClassName: 'td_right' },
    },
    {
      id: 'completedReceiptQty',
      header: '已入庫數量',
      accessorFn: (row) => formatDisplayQty(
        row?.qtySummary?.completedReceiptQty ?? row?.completedReceiptQty,
      ),
      size: 120,
      enableSorting: false,
    },
  ];
}
